module.exports = __webpack_public_path__ + "img/12218_18.98cd45ae.png";